import { aboutInfo } from '@/mocks/home';

export default function About() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-2">{aboutInfo.title}</h2>
        <p className="text-sm text-foreground-600 mb-8">{aboutInfo.subtitle}</p>
        <p className="text-sm text-foreground-700 leading-relaxed max-w-[700px] mx-auto mb-10">
          {aboutInfo.desc}
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {aboutInfo.stats.map((stat) => (
            <div key={stat.label} className="bg-background-100 rounded-xl p-6">
              <div className="text-2xl md:text-3xl font-heading text-primary-600 mb-1">{stat.value}</div>
              <div className="text-xs text-foreground-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}